import { Link } from 'react-router-dom'

const RoundedBorderButtonLink = (props) => {
    return (
        <Link to={props.path} className='flex-1'>
            <button className='w-full h-12 border border-accent rounded-[6.25rem]'>
                <p className='font-montserrat font-bold text-accent'>{props.text}</p>
            </button>
        </Link>
    )
}

export default RoundedBorderButtonLink